<template>
  <div ref="print_ref" style="display: block">
    <div style="text-align: center;">
	    <div style="font-size: 24px;font-weight: bold;margin-bottom: 6px;">件數：{{params.count}}</div>
	    <div style="font-size: 30px;font-weight: bold;margin-bottom: 6px;">門店：{{params.store}}</div>
	    <div style="font-size: 24px;font-weight: bold;margin-bottom: 6px;">袋號：{{params.sack_number}}</div>
	    <img id="barcode" src="" alt="">
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import JsBarcode from 'jsbarcode'

export default {
  name: "PrintInCode3",
  data() {
    return {
      print_ref: null,
      params: {
	      count: '11',
	      sack_number: '23213212313',
	      store: '鏡湖',
      },
			logourl: ''
    }
  },
  created() {

  },
	mounted() {
  	let _this = this
		/*this.convertImgToBase64('https://jyb-server.s3.ap-southeast-1.amazonaws.com/storage/logo/logo.png', function(base64Img){
			console.log(base64Img)
			_this.logourl = base64Img;
		});*/
	},
	methods: {
		convertImgToBase64(url, callback, outputFormat){
			let canvas = document.createElement('CANVAS'),
					ctx = canvas.getContext('2d'),
					img = new Image;
			img.crossOrigin = 'Anonymous';
			img.onload = function(){
				canvas.height = img.height;
				canvas.width = img.width;
				ctx.drawImage(img,0,0);
				const dataURL = canvas.toDataURL(outputFormat || 'image/png');
				callback.call(this, dataURL);
				canvas = null;
			};
			img.src = url;
		},
    async generateQR(text) {
      try {
        return await QRCode.toDataURL(text,{
          margin: 0,
          quality: 1
        })
      } catch (err) {
        this.$Message.error('打印二维码生成失败，请重试')
        console.error(err)
      }
    },
		bindBarCode(selector,text){
			try {
				JsBarcode(selector, text, {
					format: 'CODE128',
					fontOptions: "bold",
					displayValue: false,
					width: 1,
					height: 50,
					margin: 0 // 一维码与容器的margin
				})
			} catch (e) {
				alert('打印条形码生成失败，请重试')
			}
		},
		testPrint() {
			this.printCode({
				count: 1,
				sack_number: 'YT654654654654644',
				store: '鏡湖',
			})
		},
    printCode(val,cb) {
      console.log(val)
	    this.bindBarCode('#barcode',val)
      this.params = {
	      count: val.count || '---',
	      sack_number: val.sack_number || '---',
	      store: val.store || '---',
      }
	    
	    console.log(this.params)
	    this.$nextTick(() => {
		    try {
			    let pp = this.$refs.print_ref.innerHTML
			    console.log(pp)
			    LODOP.SET_PRINT_PAGESIZE(1, '80mm', '50mm');
			    LODOP.ADD_PRINT_HTM('1%', '2%', '100%', '100%', pp);
			    // LODOP.PREVIEW();
			    // LODOP.PRINT_SETUP();
			    LODOP.PRINT();
			    cb('yes')
		    }catch (e) {
			    cb('error')
		    }
		
	    })
      
      
      
      return
      
      
      
      this.$Rq.requestAuth({
        url: this.$Api.deliverCode4,
        method: 'get',
        data: {
          order: val.order,
          user_phone: val.user_phone,
          store_id: val.store_id
        },
      }).then(async res => {
        if (res.code !== 0) {
          cb('error')
          return this.$Message.error(res.msg)
        }
        const resData = res.data || {}
        const qrCodeUrl = await this.generateQR(val.order)
        const phone = val.user_phone.substring(val.user_phone.length - 5)
        this.params = {
          store: resData.arrive_name ,
          order: resData.order || val.order,
          user_id: resData.user_id,
          user_name: resData.user_name,
          phone,
          qrCodeUrl,
          date: resData.order_date
        }
        console.log(this.params)
        this.$nextTick(() => {
        	try {
						let pp = this.$refs.print_ref.innerHTML
						console.log(pp)
						LODOP.SET_PRINT_PAGESIZE(1, '80mm', '60mm');
						LODOP.ADD_PRINT_HTM('1%', '2%', '100%', '100%', pp);
						// LODOP.PREVIEW();
						// LODOP.PRINT_SETUP();
						LODOP.PRINT();
						cb('yes')
					}catch (e) {
						cb('error')
					}

        })
      })
    }
  }
}
</script>

<style scoped>

</style>
